import React from 'react'
import { Link, IndexLink } from 'react-router'
import lib from 'lib/commons'

export default class Header extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
    }
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  render() {
    let { currentUser: { login, user } } = this.props
    
    return (
      <header id="header">
        
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/Header.js